import Vue from 'vue';
import VueGoogleCharts from 'vue-google-charts';

Vue.use(VueGoogleCharts);
